import { css } from '@huspy/styled-system/css';

const feeFinanceBreakdownStyles = {
  feeFinancingHeader: css({
    width: '100%',
    borderTopRadius: 'radius-4',
    backgroundColor: 'utility-blue-400',
    paddingX: 4,
    paddingY: 2,
  }),
  feeFinancingContent: css({
    width: '100%',
    borderBottomRadius: 'radius-4',
    border: '1px solid',
    borderColor: 'border-secondary',
    backgroundColor: 'bg-secondary',
    padding: 4,
    gap: 5,
  }),
  feeFinancingSeparator: css({
    width: '100%',
    height: '1px',
    backgroundColor: '#000',
    marginY: 3,
  }),
  feeFinancingTable: css({
    borderCollapse: 'separate',
    borderSpacing: '0 5px',
  }),
};

export default feeFinanceBreakdownStyles;
